import { render, staticRenderFns } from "./stun_servers.vue?vue&type=template&id=3062803e&"
import script from "./stun_servers.vue?vue&type=script&lang=js&"
export * from "./stun_servers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports